import { Reducer } from "redux";

import { GatesAction, GatesActionTypes, GatesState } from "./types";

const initialState: GatesState = {
  gates: [],
  isLoaded: false,
  selectedGate: undefined,
};

const reducer: Reducer<GatesState, GatesAction> = (state = initialState, action) => {
  switch (action.type) {
    case GatesActionTypes.FETCH_SUCCESS: {
      const { items } = action.payload;
      return { ...state, isLoaded: true, gates: items };
    }

    case GatesActionTypes.SELECT: {
      const { gateId } = action.payload;
      return { ...state, selectedGate: gateId };
    }

    default:
      return state;
  }
};

export default reducer;
